import { useMemo } from 'react'

import { TeamResponse } from '@/api/generated'
import { Dropdown, DropdownItem } from '@/components/Dropdown'

// Each cost center auto-seeds its own "General" team, so names can collide
// across an enterprise with multiple cost centers — disambiguate with the
// cost center name whenever a name isn't unique.
export function buildTeamDropdownItems(teams: TeamResponse[], selectedTeamId: string | null): DropdownItem[] {
  const nameCounts = new Map<string, number>()
  for (const team of teams) {
    nameCounts.set(team.name, (nameCounts.get(team.name) ?? 0) + 1)
  }
  return teams.map((team) => ({
    id: team.id,
    title: (nameCounts.get(team.name) ?? 0) > 1 ? `${team.name} (${team.cost_center_name})` : team.name,
    selected: team.id === selectedTeamId,
  }))
}

interface TeamDropdownProps {
  teams: TeamResponse[]
  selectedTeamId: string | null
  onSelect: (teamId: string) => void
  placeholder: string
  disabled?: boolean
  width?: number | string
}

export const TeamDropdown = (props: TeamDropdownProps) => {
  const { teams, selectedTeamId, onSelect, placeholder, disabled, width } = props

  const teamItems = useMemo(() => buildTeamDropdownItems(teams, selectedTeamId), [teams, selectedTeamId])

  const handleSelect = (items: DropdownItem[]) => {
    onSelect(items[0].id)
  }

  return (
    <Dropdown
      items={teamItems}
      setItems={() => {}} // Selection is managed via handleSelect
      searchable={false}
      onSelect={handleSelect}
      placeholder={placeholder}
      disabled={disabled}
      width={width}
    />
  )
}
